/** Minimal success/failure union used at parsing and transport boundaries. */

/** A successful outcome carrying `value`. */
export interface Ok<T> { readonly ok: true; readonly value: T }

/** A failed outcome carrying a typed `error`. */
export interface Err<E> { readonly ok: false; readonly error: E }

/** Either a success carrying `T` or a failure carrying `E`. */
export type Result<T, E> = Ok<T> | Err<E>;

/** Wraps `value` as a success. */
export function ok<T>(value: T): Ok<T> {
  return { ok: true, value };
}

/** Wraps `error` as a failure. */
export function err<E>(error: E): Err<E> {
  return { ok: false, error };
}
